import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { OrganizationFeatures } from '@/types/organization';
import { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

export const getOrganizationFeatures = async (
  scope: RequestScope,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<OrganizationFeatures>> => {
  try {
    const result = await scopedChannelApi(scope).get<OrganizationFeatures | { data?: OrganizationFeatures }>('platform/features', options);
    // The `in` check needs an object guard: a null/204 body must surface the
    // clean missing-data error below, not a TypeError.
    const raw = result.data;
    let responseData: OrganizationFeatures;
    if (raw && typeof raw === 'object' && 'organization_name' in raw) {
      responseData = raw;
    } else {
      const nested = raw && typeof raw === 'object' ? (raw as { data?: OrganizationFeatures }).data : undefined;
      if (!nested) throw new Error('Organization features response did not include data');
      responseData = nested;
    }

    return {
      data: responseData,
      status: result.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
